let initialHeight

const MobileNav = {
  el: {
    body: document.querySelector<HTMLElement>('.body'),
    hamburger: document.querySelector<HTMLAnchorElement>('.top__link--hamburger'),
    nav: document.querySelector<HTMLElement>('.mobile-nav'),
    levelTriggers: document.querySelectorAll<HTMLButtonElement>('.mobile-nav__link-icon'),
    levels: document.querySelectorAll<HTMLElement>('.mobile-nav__subfloor'),
    firstLevelItems: document.querySelectorAll<HTMLElement>('.mobile-nav__list > li'),
    backButtons: document.querySelectorAll<HTMLButtonElement>('.mobile-nav .back-button'),
    wrap: document.querySelector<HTMLElement>('.mobile-nav__list'),
  },

  init() {
    this.registerEvents()
  },

  registerEvents() {
    if (this.el.hamburger) {
      this.el.hamburger.addEventListener('click', e => {
        e.preventDefault()
        this.handleMobileNav()
      })
    }

    if (this.el.levelTriggers) {
      Array.prototype.forEach.call(this.el.levelTriggers, item => {
        item.addEventListener('click', (e: Event & {target: HTMLButtonElement}) => {
          this.handleLevelSwitch(e)
        })
      })
    }

    if (this.el.backButtons) {
      Array.prototype.forEach.call(this.el.backButtons, item => {
        item.addEventListener('click', (e: Event & {target: HTMLButtonElement}) => {
          e.preventDefault()
          const levelNumber = parseInt(e.target.dataset.levelNumber)

          if (levelNumber === 1) {
            this.setFirstLevel(false)
          }

          this.setSubLevel(e.target.dataset.level, true)
        })
      })
    }
  },

  handleLevelSwitch(e: Event & {target: HTMLButtonElement}) {
    initialHeight = this.el.wrap.clientHeight

    this.setFirstLevel(initialHeight)
    this.setSubLevel(e.target.dataset.level)
  },

  setFirstLevel(out: boolean = true, initHeight = 0) {
    let transform = 'translateX(-100%)'

    if (!out) {
      transform = 'translateX(0)'
      this.resizer(this.el.wrap, initialHeight)
    }

    Array.prototype.forEach.call(this.el.firstLevelItems, item => item.style.transform = transform)
  },

  setSubLevel(level: string, out: boolean = false) {
    Array.prototype.forEach.call(this.el.levels, item => {
      if(item.dataset.level === level) {
        if(out) {
          this.removeIn(item)
        }
        else {
          this.setIn(item)
          this.resizer(this.el.wrap, item.clientHeight)

        }
      }
    })
  },

  resizer(element, size = 0) {
    // currentWitdh / targetWidth
    let height = element.clientHeight 

    if (size > 0) {
      this.el.wrap.style.height = `${size}px`;
    }
    else {
      this.el.wrap.style.height = `${height}px`
    }
  },

  setIn(item: HTMLElement) {
    item.classList.add('in')
  },
  setOut(item: HTMLElement) {
    item.classList.add('out')
  },
  removeIn(item: HTMLElement) {
    item.classList.remove('in')
  },
  removeOut(item: HTMLElement) {
    item.classList.remove('out')
  },

  handleMobileNav() {
    if (this.el.nav) {
      if (this.el.nav.classList.contains('open')) {
        this.el.nav.classList.remove('open')
        this.el.body.classList.remove('mobile-nav-open')
      }
      else {
        this.el.nav.classList.add('open')
        this.el.body.classList.add('mobile-nav-open')
      }
    }
  }
}
export default MobileNav
